import classNames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { ReactNode } from 'react';

interface RowGroupProps {
  children: ReactNode;
  isFirst?: boolean;
  labelKey: IntlKey;
  className?: string;
}

interface UnlabeledRowGroupProps {
  children: ReactNode;
  isFirst?: boolean;
  className?: string;
}
export interface FlexRowGroupProps extends RowGroupProps {
  labelWidth?: 25 | 50 | 75 | 100;
  inputId?: string;
}
type ColWidth = '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';
export interface GridRowGroupProps extends RowGroupProps {
  labelCol?: ColWidth;
  contentCol?: ColWidth;
}
function RowGroup({ isFirst = false, label, content }: { isFirst?: boolean; label: ReactNode; content: ReactNode }) {
  return (
    <div className={classNames('card', { 'border-start border-bottom border-end': !isFirst, border: isFirst })}>
      <div className="card-body d-flex justify-content-between align-items-center px-4 py-3">
        {label}
        {content}
      </div>
    </div>
  );
}

export function FlexRowGroup({ children, labelKey, isFirst, className, labelWidth, inputId }: FlexRowGroupProps) {
  return (
    <RowGroup
      isFirst={isFirst}
      label={
        <label className={labelWidth ? `w-${labelWidth}` : 'w-25'} htmlFor={inputId}>
          <FormattedMessage id={labelKey} />
        </label>
      }
      content={<div className={classNames('flex-grow-1 d-flex justify-content-end', className)}>{children}</div>}
    ></RowGroup>
  );
}

export function FlexRowGroupWithNoLabel({ children, isFirst, className }: UnlabeledRowGroupProps) {
  return (
    <RowGroup
      isFirst={isFirst}
      label={null}
      content={<div className={classNames('flex-grow-1 d-flex justify-content-end', className)}>{children}</div>}
    ></RowGroup>
  );
}

export function GridRowGroup({ children, labelKey, isFirst, className, labelCol, contentCol }: GridRowGroupProps) {
  return (
    <RowGroup
      isFirst={isFirst}
      label={
        <label className={`col-${labelCol}`}>
          <FormattedMessage id={labelKey} />
        </label>
      }
      content={
        <div className={classNames(`flex-grow-1 d-flex justify-content-end col-${contentCol}`, className)}>
          {children}
        </div>
      }
    ></RowGroup>
  );
}
